import { types } from 'mobx-state-tree';
import { Shape } from './shape-model';

export const SVGElement = Shape.named('SVGElement')
  .props({
    type: types.optional(types.string, 'svg'),
    src: types.optional(types.string, ''),
    maskSrc: types.optional(types.string, ''),
    cropX: types.optional(types.number, 0),
    cropY: types.optional(types.number, 0),
    cropWidth: types.optional(types.number, 1),
    cropHeight: types.optional(types.number, 1),
    keepRatio: types.optional(types.boolean, true),
    stretchEnabled: types.optional(types.boolean, false),
    flipX: types.optional(types.boolean, false),
    flipY: types.optional(types.boolean, false),
    borderColor: types.optional(types.string, ''),
    borderSize: types.optional(types.number, 0),
    cornerRadius: types.optional(types.number, 0),
    colorsReplace: types.optional(types.map(types.string), {}),
  })
  .actions((self) => ({
    replaceColor(oldColor, newColor) {
      self.colorsReplace.set(oldColor, newColor);
    },
  }));
